import * as React from 'react';

import { CollapsedBlock } from '../CollapsedBlock';
import { ICollapsedButtonProps } from '../CollapsedBlock/CollapsedButton';
import * as styles from './styles.css';

export interface IPromos {
  Button: React.ComponentType<ICollapsedButtonProps>;
  onChangeOpen(opened: boolean): void;
}

export const Promos = ({ children, Button, onChangeOpen }: React.PropsWithChildren<IPromos>) => {
  return (
    <div className={styles['promos']}>
      <CollapsedBlock collapsedHeight={94} Button={Button} onChangeOpen={onChangeOpen}>
        <div className={styles['collapsed-block']}>
          <div className={styles['row']}>{children}</div>
        </div>
      </CollapsedBlock>
    </div>
  );
};
